import { useMediaQuery, CircularProgress, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBackIos";
import { AppBar, Toolbar, IconButton, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import ResponsiveCourseNavnarForDivices from "../component/NavBar/ResponsiveNavbarForDivices";
import EbookFlipCard from "../component/mobile/student/EbookFlipCard";
import axios from "axios";
import endpoints from "../endpoint";

const EbookDetailsPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [ebook, setEbook] = useState(null);
  console.log("ebook", ebook);

  const [loading, setLoading] = useState(true);
  const isMobile = useMediaQuery("(max-width:767px)");
  console.log("EbookDetailsPage - Received ID:", id);
  useEffect(() => {
    const fetchEbookDetails = async () => {
      try {
        const response = await axios.get(
          `${endpoints.serverBaseUrl}api/ebook/${id}`
        );
        setEbook(response.data);
      } catch (error) {
        console.error("Failed to fetch ebook details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEbookDetails();
  }, [id]);

  return (
    <div>
      {isMobile ? (
        <AppBar
          position="sticky"
          sx={{
            backgroundColor: "white",
            borderBottomLeftRadius: "0.5rem",
            borderBottomRightRadius: "0.5rem",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => navigate("/")}
            >
              <ArrowBackIcon sx={{ color: "black" }} />
            </IconButton>
            <Typography variant="h6" sx={{ flexGrow: 1, color: "black" }}>
              {ebook?.ebook?.title}

              {/* sdfsfs */}
            </Typography>
          </Toolbar>
        </AppBar>
      ) : (
        <ResponsiveCourseNavnarForDivices />
      )}

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : ebook ? (
        <EbookFlipCard ebook={ebook} />
      ) : (
        <Typography sx={{ textAlign: "center", mt: 4 }}>
          Ebook not found
        </Typography>
      )}
    </div>
  );
};

export default EbookDetailsPage;
